"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeltaType = void 0;
var DeltaType;
(function (DeltaType) {
    DeltaType["Insert"] = "insert";
    DeltaType["Update"] = "update";
    DeltaType["Delete"] = "delete";
    DeltaType["Move"] = "move";
})(DeltaType = exports.DeltaType || (exports.DeltaType = {}));
//# sourceMappingURL=delta.js.map